import React, { createContext, useContext } from 'react';
import { partesComUc } from './ucNoTexto.ts';

/**
 * #6587: quem fornece este contexto (a janela da solicitação) liga a UC clicável no
 * título, na descrição e nos comentários. Sem ele, ComentarioTexto e
 * TaskDescriptionMarkdown seguem como sempre (Projetos, feed do CRM).
 */
export interface UcCitadaContexto {
    conhecidos: ReadonlySet<string>;
    /** `origem`: o botão clicado, para devolver o foco a ele se a janela for cancelada. */
    abrir: (numeroNormalizado: string, origem?: HTMLElement) => void;
}

export const UcCitadaContext = createContext<UcCitadaContexto | null>(null);

export const useUcCitada = () => useContext(UcCitadaContext);

export const UcCitadaBotao: React.FC<{ numero: string; children: React.ReactNode }> = ({ numero, children }) => {
    const ctx = useUcCitada();
    if (!ctx) return <>{children}</>;
    // O número sozinho, lido por leitor de tela, não diz que é uma UC nem o que o clique faz.
    const exibido = React.Children.toArray(children).filter(c => typeof c === 'string' || typeof c === 'number').join('') || numero;
    return (
        <button type="button" onClick={e => { e.stopPropagation(); ctx.abrir(numero, e.currentTarget); }}
            title="Escolher para onde ir com esta UC"
            aria-label={`UC ${exibido}: escolher para onde ir`} aria-haspopup="dialog"
            className="inline font-semibold text-primary dark:text-primary-light underline decoration-dotted underline-offset-2 hover:decoration-solid focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 dark:focus-visible:ring-primary-light/50 rounded-sm">
            {children}
        </button>
    );
};

/** Texto puro (o título) com as UCs do cadastro clicáveis. */
export const TextoComUcs: React.FC<{ texto: string }> = ({ texto }) => {
    const ctx = useUcCitada();
    if (!ctx) return <>{texto}</>;
    return <>{partesComUc(texto, ctx.conhecidos).map((p, i) =>
        p.uc ? <UcCitadaBotao key={i} numero={p.uc}>{p.texto}</UcCitadaBotao> : <React.Fragment key={i}>{p.texto}</React.Fragment>)}</>;
};
